import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import VendorSidebar from "./VendorSidebar";
import VendorHeader from "./vendordashboard/VendorHeader";
import VendorFooter from "./vendordashboard/VendorFooter";
import { getVendorRouteInfo } from "./vendordashboard/GetVendorRouteInfo";
//import "./vendor-dashboard.css";

const VendorLayout = () => {
  const location = useLocation();
  const { pageTitle, breadcrumbs } = getVendorRouteInfo(location.pathname);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="vendor-dashboard-layout d-flex">

      {/* SIDEBAR */}
      <div className={`vendor-sidebar ${sidebarOpen ? "open" : ""}`}>
        <VendorSidebar closeSidebar={() => setSidebarOpen(false)} />
      </div>

      {/* OVERLAY (mobile) */}
      {sidebarOpen && (
        <div
          className="vendor-sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* RIGHT SIDE */}
      <div className="flex-grow-1 d-flex flex-column bg-light">

        {/* HEADER */}
        <VendorHeader
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          onMenuClick={() => setSidebarOpen(true)}
        />

        {/* CONTENT */}
        <div className="vendor-content-area p-4 pb-5">
          <Outlet />
        </div>
<VendorFooter />
      </div>
    </div>
  );
};

export default VendorLayout;
